module.exports = __webpack_public_path__ + "static/media/24.25fbb8b3.jpg";